var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLockIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 136,
    height: 161,
    viewBox: "0 0 136 161",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M68.5 37.9995C102.442 37.9995 130 65.5577 130 99.4995C130 133.441 102.442 161 68.5 161C34.5581 161 7 133.441 7 99.4995C7 65.5577 34.5581 37.9995 68.5 37.9995Z",
    fill: "#232A43"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M65.2984 42.1048L61.821 50.4979L61.1681 51.2612L65.5836 53.9802L68.835 46.1095C69.2951 44.9956 68.7941 43.717 67.6997 43.2123L65.2984 42.1048Z",
    fill: "#EEF0F6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M75.6972 84.0424C93.9945 88.5957 112.664 76.8686 117.397 57.849C122.13 38.8294 111.135 19.7198 92.8372 15.1665C78.3433 12.0225 55.8701 22.3403 51.137 41.3598C46.4039 60.3794 57.3999 79.489 75.6972 84.0424ZM79.6025 68.3491C89.4734 70.8056 99.5638 64.4046 102.14 54.0522C104.716 43.6997 98.9605 33.0322 88.9319 30.8597C81.1123 29.1657 68.9706 34.8043 66.3943 45.1567C63.8181 55.5091 69.7316 65.8927 79.6025 68.3491Z",
    fill: "#DDE1EE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M75.705 84.0439C94.0023 88.5973 95.2106 81.0315 99.9437 62.012C105.718 58.5389 111.218 32.0835 89.9525 26.7915C77.5601 23.7075 66.2065 33.1575 62.9428 42.9839C58.2097 62.0035 57.4077 79.4906 75.705 84.0439ZM79.6103 68.3507C89.4812 70.8071 99.5716 64.4061 102.148 54.0537C104.724 43.7013 98.9683 33.0338 88.9397 30.8613C81.1201 29.1673 68.9784 34.8058 66.4021 45.1582C63.8259 55.5107 69.7394 65.8943 79.6103 68.3507Z",
    fill: "#BCC3DC"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M96.934 58.5605L95.0639 62.9371L94.411 63.7004L113.76 73.3762L116.34 67.2155C116.81 66.094 116.302 64.8024 115.194 64.3014L99.9249 57.3965C98.7779 56.8778 97.4286 57.4029 96.934 58.5605Z",
    fill: "#FFC800"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M49.756 37.6521L46.8987 43.5461L46.2459 44.3094L65.5952 53.9853L68.8349 46.143C69.2997 45.0177 68.7833 43.7269 67.6706 43.2327L52.6888 36.5791C51.5818 36.0875 50.2844 36.5622 49.756 37.6521Z",
    fill: "#FFC800"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.36,
    d: "M112.827 63.1917L110.001 69.8953L109.348 70.6586L113.764 73.3777L116.35 67.202C116.817 66.0864 116.317 64.8013 115.218 64.2948L112.827 63.1917Z",
    fill: "#B58E00"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M33.0983 48.2271C35.5281 42.9027 41.7621 40.4891 47.1438 42.7894L111.577 70.3292C117.851 73.0108 120.68 80.3377 117.835 86.5392L92.5725 141.611C90.3946 146.359 84.7734 148.433 80.0337 146.238L12.8761 115.136C8.16713 112.956 6.10381 107.381 8.25826 102.66L33.0983 48.2271Z",
    fill: "#2F5DF5"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M33.0726 48.1659C35.491 42.8551 41.6959 40.4324 47.073 42.6995L107.054 67.9887C111.502 69.8639 113.511 75.0511 111.487 79.4329L84.5231 137.799C82.3387 142.528 76.7355 144.591 72.0062 142.409L12.8936 115.128C8.18002 112.952 6.10983 107.377 8.26123 102.653L33.0726 48.1659Z",
    fill: "url(#paint0_linear_1601_60395)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.0823 89.2374C67.1241 89.6945 71.1841 87.5739 73.0099 83.6881C75.3018 78.8104 73.2056 72.9983 68.3279 70.7065C63.4502 68.4146 57.6382 70.5108 55.3463 75.3885C53.6529 78.9923 54.355 83.1063 56.8046 85.9336L45.9624 99.7304L59.8409 106.252L63.0823 89.2374Z",
    fill: "#2F5DF5"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.9274 89.6877C67.5016 89.9278 71.2227 87.6559 73.045 83.7776C75.3324 78.9094 73.7617 73.3536 69.5367 71.3684C65.3117 69.3832 60.0324 71.7204 57.745 76.5886C56.0549 80.1855 56.471 84.1577 58.5077 86.7878L48.1575 100.779L60.1789 106.428L63.9274 89.6877Z",
    fill: "#111522"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1601_60395",
    x1: 27.7749,
    y1: 116.657,
    x2: 94.1684,
    y2: 61.8295,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1C5AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C9E8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockIcon);
export default __webpack_public_path__ + "static/media/LockIcon.579a12248fc8800711b0454a9e413387.svg";
export { ForwardRef as ReactComponent };